import Vue from 'vue';
import axios from 'axios';
import auth from './models/auth'
import entity from './models/entites'
import agency from './models/agences'
import atm from './models/guichets'
import commission from './models/commissions'
import tarification from './models/tarifications'
import grilletarifaire from './models/grilletarifaires'
import typepiece from './models/typedepieces'
import user from './models/users'
import mandate from './models/mandats'
import typeoperation from './models/typeoperations'
import typeoperation_headers from './models/typeoperations_headers'
import appro from './models/approvisionnements'
import planning from './models/plannings'
import role from './models/roles'
import etat from './models/etat'
import charts from './models/charts'
import plafonds from './models/plafonds'
import mouchards from './models/mouchards'
import histories from './models/histories'
import serveur from '../../server_param.json'
window.axios = axios


console.log("mon serveur : ", serveur.adresse)
// window.authStr = 'Bearer '.concat(localStorage.getItem('token'));
const token = localStorage.getItem('token')
window.token = token
const url = 'http://'+serveur.adresse
console.log(url)
//const url = 'http://149.56.46.123'
//const url = 'http://51.38.190.99'
window.url_redirect = url + '/#/pages/reset-password',
//window.url_redirect = url + '/#/pages/reset-password',
//Config de base AXIOS

//axios.defaults.baseURL = url+':'+serveur.port+'/posteone/public/api'
axios.defaults.baseURL = url +':'+serveur.port+'/api'
//axios.defaults.baseURL = 'http://192.168.1.100:8080/postone/public/api'
//axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
//axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*'
//axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
// before a request is made start the nprogress
axios.interceptors.request.use(config => {
    NProgress.done()
    NProgress.start()
    return config
})

// before a response is returned stop nprogress
// before a response is returned stop nprogress
axios.interceptors.response.use(response => {
    
    NProgress.done()
    if (response.status == 200) {
        //On ne fait rien car tout va bien
    } else {
    }
   
    return response  
},error=>{
    NProgress.done()
    //console.log("test : ", error.response.status)
        if (error.response.status == 401){
        console.log("test : ",error.response.status)
        localStorage.removeItem('token')
        localStorage.removeItem('temp_token')
        localStorage.removeItem('permissions')
        localStorage.removeItem('name')
        localStorage.removeItem('role')
        localStorage.removeItem('solde')
        localStorage.removeItem('type_entite')
        location.reload();
    }
    return Promise.reject(error)
})
//#Config AXIOS

export default {
    auth, 
    entity,
    agency,
    atm,
    commission,
    tarification,
    grilletarifaire,
    typepiece,
    user,
    mandate, 
    typeoperation,
    typeoperation_headers,
    appro,
    role,
    etat,
    charts,
    planning,
    plafonds,
    mouchards,
    histories
  }
